import * as Yup from 'yup';
import {ROLES} from 'common/constants';

export const userValidationSchema = Yup.object().shape({
  full_name: Yup.string()
    .required('Full name is required')
    .min(2, 'Full name must be at least 2 characters')
    .max(50, 'Full name must not exceed 50 characters'),
  email: Yup.string()
    .email('Invalid email format')
    .required('Email is required'),
  phone_number: Yup.string()
    .required('Phone number is required')
    .matches(/^\+?[\d\s\-\(\)]+$/, 'Invalid phone number format')
    .min(8, 'Phone number must be at least 8 characters')
    .max(13, 'Phone number must not exceed 13 characters'),
  role: Yup.string()
    .required('Role is required')
    .oneOf(Object.values(ROLES), 'Invalid role'),
  sub_role: Yup.string()
    .when('role', {
      is: (role) => role === ROLES.ADMIN || role === ROLES.GROUND_ADMIN,
      then: (schema) => schema.required('Subrole is required'),
      otherwise: (schema) => schema.optional(),
    }),
  // grounds: Yup.array()
  //   .of(Yup.string())
  //   .when('role', ([role], schema) => {
  //     return role === ROLES.GROUND_ADMIN
  //       ? schema.min(1, 'At least one ground must be selected').required('Grounds are required')
  //       : schema.notRequired();
  //   }),
  grounds: Yup.array().of(Yup.string()).notRequired(),
  is_active: Yup.boolean()
    .required('Status is required'),
  // dob: Yup.date()
  //   .required('Date of birth is required')
  //   .max(new Date(), 'Date of birth cannot be in the future')
  //   .nullable(),
  // location: Yup.object().shape({
  //   city: Yup.string()
  //     .required('City is required'),
  //   address: Yup.string()
  //     .required('Address is required')
  //     .min(10, 'Address must be at least 10 characters')
  //     .max(200, 'Address must not exceed 200 characters'),
  //   latitude: Yup.number()
  //     .min(-90, 'Latitude must be between -90 and 90')
  //     .max(90, 'Latitude must be between -90 and 90')
  //     .nullable(),
  //   longitude: Yup.number()
  //     .min(-180, 'Longitude must be between -180 and 180')
  //     .max(180, 'Longitude must be between -180 and 180')
  //     .nullable(),
  // }),
});
